// estilos
import { Search } from "lucide-react";

export const Buscar = ({ search, setSearch }) => {
  return (
    <div className="bg-white p-1.5 flex rounded-sm gap-1 w-96 items-center border-1 border-gray-300">
      <Search className="text-gray-400" size={22} />
      <input
        className="outline-none w-96 block p-1"
        type="text"
        placeholder={"Buscar por contacto, email, descripción, notas"}
        id="buscador"
        name="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </div>
  );
};
